module.exports = __webpack_public_path__ + "img/03.a19e4c32.png";